import { createContext, useEffect, useReducer } from 'react'
import { reducer } from './reducer'
import React from 'react'
import { CollectionAction, CollectionState } from './types'
import { useCollectionStories } from './useCollectionStories'
import { useSearchParams } from 'react-router-dom'

type CollectionContextType = {  
  state: CollectionState
  dispatch: (action: CollectionAction) => void
}

export const CollectionContext = createContext<CollectionContextType>({
  state: [] as CollectionState,
  dispatch: (action: CollectionAction) => {},
})

export function CollectionContextProvider({ slug, type, children }: { slug: string, type: string, children: React.ReactNode }) {
  const [state, dispatch] = useReducer(reducer, [] as CollectionState)
  const [searchParams, setSearchParams] = useSearchParams()
  const { error } = useCollectionStories(slug, type, dispatch, searchParams.get('excerpt'))


  useEffect(() => {
    const querySlug = searchParams.get('excerpt')
    const activeStorySlug = state.find((story) => story.isActive)?.slug
    if(activeStorySlug && activeStorySlug !== querySlug) {
      setSearchParams({ excerpt: activeStorySlug }, { replace: true })
    }
  }, [searchParams, state, setSearchParams])

  if (error) {
    console.error(error)
    return <p> Oops something went wrong </p>
  }

  return <CollectionContext.Provider value={{ state, dispatch }}>{children}</CollectionContext.Provider>
}

